module.exports = __webpack_public_path__ + "static/media/registraTuEstadoDeVacunacion.1b15feef.jpeg";